import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { editTable, addTable } from '@/api/userManage';
import { roleResource } from '@/api/roleManage';
import { customerResource } from './../customerManage/request';
import { isPhone, checkEmail } from '@/utils/validate';
// import standardTree from '@/components/standardTree/index';
export default {
  name: 'userModel',
  props: {
    currentRow: [Object, null],
    dialogVisible: Boolean
  },
  // components: { standardTree },
  data() {
    return {
      loginForm: {
        username: '',
        account: '',
        password: '',
        phone: '',
        code: '',
        remember: true
      },
      customerIdArr: [],
      userFrom: {
        roleIds: []
        // globalRoaming: '+86',
        // mobile: ''
      },
      loading: false,
      roleList: [],
      role: [],
      customerList: [],
      globalRoamingOptionData: [{
        label: '+86',
        value: '中国大陆',
        code: 'CN'
      }, {
        label: '+886',
        value: '中国台湾',
        code: 'TW'
      }, {
        label: '+852',
        value: '中国香港',
        code: 'HK'
      }, {
        label: '+853',
        value: '中国澳门',
        code: 'MO'
      }, {
        label: '+1',
        value: '美国',
        code: 'US'
      }, {
        label: '+65',
        value: '新加坡',
        code: 'SG'
      }]
    };
  },
  computed: {
    userRule() {
      return {
        nickName: [{
          required: true,
          trigger: 'blur',
          message: this.$t('管理员名称不能为空')
        }, {
          min: 1,
          max: 100,
          message: this.$t('长度应最少一位,最多一百位'),
          trigger: 'blur'
        }],
        appointCustomerId: [{
          required: true,
          type: 'array',
          validator: this.validateCustomer,
          trigger: 'change'
        }],
        mobile: [{
          required: true,
          validator: this.validatePhone,
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: this.$t('请输入') + this.$t('管理员账号'),
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9@.]+$/,
          message: this.$t('仅限输入大小写字母、数字、特殊符号“@”和“.”'),
          trigger: 'blur'
        }, {
          min: 8,
          max: 50,
          message: this.$t('请输入8-50字符'),
          trigger: 'blur'
        }],
        roleId: [{
          type: 'array',
          required: true,
          message: this.$t('角色必填'),
          trigger: 'change'
        }],
        password: this.currentRow ? [{
          min: 8,
          max: 16,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }, {
          pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,16}$/,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }] : [{
          required: true,
          message: this.$t('请输入') + this.$t('登录密码'),
          trigger: 'blur'
        }, {
          min: 8,
          max: 16,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }, {
          pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,16}$/,
          message: this.$t('请输入8-16位数字、大小写字母组合'),
          trigger: 'blur'
        }],
        email: [{
          required: false,
          validator: this.checkEmail,
          trigger: 'blur'
        }]
        // roleIds: [{ required: true, trigger: 'blur', message: '角色必填！' }],
      };
    }
  },
  created() {
    // 自定义方法 async
    // // 1、获取当前页面的域名，并存储在 hostname 变量中
    // const hostname = window.location.hostname;
    // //2、 然后，代码检查 hostname 是否包含特定的国内和海外域名。
    // if (hostname.includes('console.insureforce.cn')) {
    //   // 3、如果是国内域名（console.insureforce.cn），则将手机号区号设置为 '+86'，并将其存储在 sessionStorage 中。
    //   // 国内域名，默认手机区号为 +86
    //   this.$set(this.loginForm, 'globalRoaming', '+86');
    //   sessionStorage.setItem('globalRoaming', '+86');
    // } else if (hostname.includes('console.sg.insurforce.ai')) {
    //   //4、 如果是海外域名（console.sg.insurforce.ai），则将手机号区号设置为 '+1'，并将其存储在 sessionStorage 中。
    //   // 海外域名，默认手机区号为 +1
    //   this.$set(this.loginForm, 'globalRoaming', '+1');
    //   sessionStorage.setItem('globalRoaming', '+1');
    // } else {
    //   this.$set(this.loginForm, 'globalRoaming', '+86');
    //   sessionStorage.setItem('globalRoaming', '+86');
    // }
    // //5、 接下来，代码检查 sessionStorage 中是否存在键为 'changeLocale' 的项。
    // // 如果不存在，根据当前域名确定当前语言环境（'zh_CN' 或 'en_US'），并将其保存到 sessionStorage 和 Vuex store 中。
    // if (!sessionStorage.getItem('changeLocale')) {
    //   const locale = hostname.includes('console.insurforce.cn') ? 'zh_CN' : 'en_US';
    //   this.$store.commit('setting/CHANGE_LOCALE', locale);
    //   sessionStorage.setItem('locale', locale);
    // }
    // setTimeout(() => {
    //   if (!this.currentRow) {
    //     this.userRule.password.push({
    //       required: true,
    //       message: this.$t('请输入') + this.$t('登录密码'),
    //       trigger: 'blur'
    //     });
    //   }
    // }, 400);
  },
  async mounted() {
    // this.currentRow.appointCustomerId=this.currentRow.appointCustomerId||undefined;
    this.userFrom = {
      ...this.currentRow,
      roleId: []
    } || {
      roleId: [],
      // 原始
      // globalRoaming: sessionStorage.getItem('globalRoaming') || '+86',
      globalRoaming: sessionStorage.getItem('globalRoaming') || "process.env.VUE_APP_BASE_API?.includes('console.insureforce.cn')? '+86': '+1'",
      mobile: ''
    };
    if (!this.currentRow) {
      // 原始
      // let globalRoaming = sessionStorage.getItem('globalRoaming') || '+86';
      let globalRoaming = sessionStorage.getItem('globalRoaming') || "process.env.VUE_APP_BASE_API?.includes('console.insureforce.cn')? '+86': '+1'";
      this.$set(this.userFrom, 'globalRoaming', globalRoaming);
      this.$set(this.userFrom, 'mobile', '');
    }
    await roleResource({
      userId: this.currentRow ? this.currentRow.id : ''
    }).then(res => {
      this.roleList = res;
      res.map(item => {
        if (item.selected) {
          this.userFrom.roleId.push(item.id);
        }
      });
    });
    await customerResource({
      isAll: 1
    }).then(res => {
      if (this.currentRow) {
        if (res.length == this.currentRow.appointCustomerId.split(',').length) {
          this.customerIdArr = [-1];
        } else if (this.currentRow.appointCustomerId) {
          this.currentRow.appointCustomerId.split(',').map(item => {
            const obj = res.find(item2 => item2.id == item);
            if (obj) {
              this.customerIdArr.push(Number(item));
            }
          });
        }
      }
      this.customerList = res;
      this.customerList.unshift({
        id: -1,
        mark: '',
        name: this.$t('全部')
      });
    });
  },
  methods: {
    checkEmail(rule, value, callback) {
      let regEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !regEmail.test(value)) {
        callback(new Error(this.$t('邮箱有误，请重新填写')));
      } else {
        callback();
      }
    },
    handleBlurTrim(key) {
      this.userFrom[key] = this.userFrom[key].trim();
    },
    validateCustomer(rule, value, callback) {
      console.log(this);
      if (this.customerIdArr.length == 0) {
        callback(new Error(this.$t('客户必选')));
      } else {
        callback();
      }
    },
    validateAccount(rules, value, callback) {
      if (!value) {
        callback(new Error(this.$t('管理员账号不能为空') + '!'));
      }
      let reg = /^[\w@.\-_]+$/;
      if (!reg.test(value)) {
        callback(new Error(this.$t('仅限输入大小写字母、数字或特殊字符“@”和“.”“-”“_”')));
      }
      callback();
    },
    validatePhone(rule, value, callback) {
      const regMap = {
        CN: /^1[3456789]\d{9}$/,
        // 中国
        TW: /^09\d{8}$/,
        // 台湾
        HK: /^([6|9])\d{7}$/,
        // 香港
        MO: /^[6]\d{7}$/,
        // 澳门
        US: /^[1-9]\d{9}$/,
        // 美国
        SG: /^[89]\d{7}$/ // 新加坡
      };
      let findItem = this.globalRoamingOptionData.find(item => item.label === this.userFrom.globalRoaming);
      if (findItem && findItem.length === 0) {
        callback();
      }
      let regValue = regMap[findItem.code];
      if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('手机号')));
      } else if (!regValue.test(value)) {
        callback(new Error(this.$t('手机号码格式有误，请重新填写')));
      } else {
        callback();
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleSure() {
      this.$refs.userFrom.validate(valid => {
        if (valid) {
          // if (this.userFrom.mobile) {
          //   if (!isPhone(this.userFrom.mobile)) {
          //     return this.$message.error('手机号码有误，请重新填写');
          //   }
          // }
          // if (this.userFrom.email) {
          //   if (!checkEmail(this.userFrom.email)) {
          //     return this.$message.error(this.$t('邮箱有误，请重新填写'));
          //   }
          // }
          this.userFrom.roleIds = this.userFrom.roleId.join(',');
          if (this.customerIdArr.join(',').indexOf('-1') > -1) {
            let arr = [];
            this.customerList.map(item => {
              if (item.id != -1) {
                arr.push(item.id);
              }
            });
            this.userFrom.appointCustomerId = arr.join(',');
          } else {
            this.userFrom.appointCustomerId = this.customerIdArr.join(',');
          }
          if (this.currentRow) {
            //编辑
            this.userFrom.userId = this.userFrom.id;
            editTable(this.userFrom).then(() => {
              this.$message.success(this.$t('修改成功'));
              this.loading = false;
              this.$emit('ok');
            });
          } else {
            //新增
            addTable(this.userFrom).then(() => {
              this.$message.success(this.$t('添加成功'));
              this.loading = false;
              this.$emit('ok');
            });
          }
        }
      });
    },
    checkboxFun(val) {
      val.selected = !val.selected;
      let arr = [];
      this.roleList.map(item => {
        if (item.selected) {
          arr.push(item.id);
        }
      });
      this.userFrom.roleIds = arr.join(',');
    },
    changeGlobalRoaming() {
      this.$set(this.userFrom, 'mobile', '');
      // this.$refs.userFrom.validateField('mobile');
    }
  }
};